import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Alert, Card } from 'react-bootstrap';

function Booking() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    client_name: '',
    client_email: '',
    client_phone: '',
    client_company: '',
    service_id: '',
    booking_date: '',
    booking_time: '',
    notes: ''
  });
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetch(`${baseURL}/services-page.php`)
      .then(response => response.json())
      .then(data => {
        console.log('API Response:', data); // Debug log
        // Fix: Access data.services instead of data
        if (data.success && Array.isArray(data.services)) {
          setServices(data.services);
        } else {
          console.error('Unexpected API response:', data);
          setServices([]);
        }
      })
      .catch(error => {
        console.error('Error fetching services:', error);
        setServices([]);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch(`${baseURL}/bookings.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      
      setAlert({
        show: true,
        type: 'success',
        message: result.message || 'Booking request submitted successfully! We will contact you shortly.'
      });
      
      // Reset form
      setFormData({
        client_name: '',
        client_email: '',
        client_phone: '',
        client_company: '',
        service_id: '',
        booking_date: '',
        booking_time: '',
        notes: ''
      });
    } catch (error) {
      setAlert({
        show: true,
        type: 'danger',
        message: 'Error submitting booking. Please try again or contact us directly.'
      });
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={8}>
          <Card className="booking-form">
            <Card.Body>
              <h2 className="text-center royal-blue-text mb-4">Request a Quote</h2>
              
              {alert.show && (
                <Alert variant={alert.type} onClose={() => setAlert({...alert, show: false})} dismissible>
                  {alert.message}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Full Name *</Form.Label>
                      <Form.Control
                        type="text"
                        name="client_name"
                        value={formData.client_name}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email *</Form.Label>
                      <Form.Control
                        type="email"
                        name="client_email"
                        value={formData.client_email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Phone Number *</Form.Label>
                      <Form.Control
                        type="tel"
                        name="client_phone"
                        value={formData.client_phone}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Company/Institution</Form.Label>
                      <Form.Control
                        type="text"
                        name="client_company"
                        value={formData.client_company}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Service Required *</Form.Label>
                      <Form.Select
                        name="service_id"
                        value={formData.service_id}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select a service</option>
                        {loading ? (
                          <option disabled>Loading services...</option>
                        ) : (
                          // Fix: services is now properly an array
                          services.map(service => (
                            <option key={service.id} value={service.id}>
                              {service.name || service.title} {/* Use name or title depending on your DB */}
                            </option>
                          ))
                        )}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Preferred Date *</Form.Label>
                      <Form.Control
                        type="date"
                        name="booking_date"
                        value={formData.booking_date}
                        onChange={handleChange}
                        required
                        min={new Date().toISOString().split('T')[0]} // Prevent past dates
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Preferred Time *</Form.Label>
                      <Form.Control
                        type="time"
                        name="booking_time"
                        value={formData.booking_time}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-4">
                  <Form.Label>Additional Notes</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="notes"
                    value={formData.notes}
                    onChange={handleChange}
                    placeholder="Please provide any specific requirements or details about your needs..."
                  />
                </Form.Group>

                <div className="text-center">
                  <Button 
                    variant="primary" 
                    type="submit" 
                    size="lg"
                    disabled={loading}
                  >
                    {loading ? 'Loading...' : 'Submit Quote Request'}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default Booking;